export function isVideos(value) {
  return value === 'videos'
}
